
import lazyload from "@/directives/lazyload";
export default {
  data() {
    return {
    };
  },
  directives: {
    lazyload,
  },
};
